<script>
import { mapState,mapActions } from "vuex";
import { mapFields } from "@/helpers/mapFields";
import { calculateDistanceAndTime } from "@/helpers/utils";
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    directionsService: null,
    directionsRenderer: null,
  }),
  computed: {
    ...mapState("service", ["auxModel"]),
    ...mapFields({
      fields: ["travelLength", "travelTime"],
      base: "auxModel",
      mutation: "SET_UPDATE_AUXMODEL",
      module: "service",
    }),
  },
  methods: {
    ...mapActions("global", ["_triggerEventMkt"]),
    init() {
      this.directionsService = new this.google.maps.DirectionsService();
      this.directionsRenderer = new this.google.maps.DirectionsRenderer();
      this.directionsRenderer.setMap(this.map);
      if (this.isSelectedPickupAndDropoff()) this.updateDirections();
      this.showDriverLocation();

    },
    showDriverLocation() {
      if (this.auxModel.trackingStatus === "atPickup" && this.auxModel.driverLocation) {
        this._triggerEventMkt("with_driver_location");
        const { latitude, longitude } = this.auxModel.driverLocation;
        const driverLatLng = new this.google.maps.LatLng(latitude, longitude);

        // Update marker if it already exists
        if (this.driverMarker) {
          this.driverMarker.setPosition(driverLatLng);
        } else {
          // Custom driver icon (e.g. a car icon)
          const driverIcon = {
            url: "https://maps.gstatic.com/mapfiles/ms2/micons/cabs.png", // you can use your own custom car icon
            scaledSize: new this.google.maps.Size(25, 25), // adjust size as needed
          };

          this.driverMarker = new this.google.maps.Marker({
            position: driverLatLng,
            map: this.map,
            title: "Your Driver",
            icon: driverIcon,
            animation: this.google.maps.Animation.DROP,
          });

          // Optional: info window with driver details
          const infoWindow = new this.google.maps.InfoWindow({
            content: `<strong>Your driver is here</strong><br>`,
          });

          this.driverMarker.addListener("click", () => {
            infoWindow.open(this.map, this.driverMarker);
          });
        }

        // Optionally center the map on the driver
        // this.map.setCenter(driverLatLng);
      }
    },
    isSelectedPickupAndDropoff() {
      if (
        this.auxModel.pickup?.latitude &&
        this.auxModel.pickup?.longitude &&
        this.auxModel.dropoff?.latitude &&
        this.auxModel.dropoff?.longitude
      )
        return true;
      return false;
    },
    async updateDirections() {
      try {
        const { time, length, data } = await calculateDistanceAndTime(
          this.auxModel
        );
        this.directionsRenderer.setDirections(data);
        this.travelTime = time;
        this.travelLength = length;
      } catch (e) {
        console.log(e)
      }
    },
  },
  async mounted() {
    this.init();
  },
  // eslint-disable-next-line
  render() {},
};
</script>
